// Cart related
store.cart = {};

/**
 * @todo What should be done with the message !
 * @param params
 */
store.cart.add = function (params) {
	var isFormData = params instanceof FormData;
	var $form;
	var $body = $('body');
	if (this && this.tagName === 'FORM') {
		$form = $(this);
	}
	else {
		$form = $('#store').find('form.cartAdd');
	}
	$body.addClass('cart-adding');
	document.body.style.cursor = 'wait';
	$.ajax({
		type: 'POST',
		url: store.url(store.action.cartAdd),
		data: params,
		cache: false,
        contentType: isFormData ? false : false,
        processData: isFormData ? false : false,
		dataType: 'json',
		success: function (data) {
			$body.removeClass('cart-adding');
			document.body.style.cursor = 'default';

			if (!data) {
				return;
			}
			// var className = (data.success) ? 'success' : 'error';
			// example: moya.message.add(data.message, className);
			if (data.success === true) {
				store.cart.box();
				store.message.add(data.message, data.title, data.image, null, 'cartAdd');
				store.customize.onAddToCart(data);
				store.local.onAddToCart(data);
			}
			else {
				store.message.error(data.message, data.title, null, 'cartAdd');
				if (data.fields && data.fields.length && $form && $form.length > 0) {
					for (var i = 0; i < data.fields.length; i++) {
						var field = data.fields[i];
						var $elm = $form.find('#elm_' + field);
						$elm.addClass('hasError');
						if (i === 0) {
							$elm.find(':input').first().focus();
						}
					}
				}
			}
		}
	});
};

store.cart.remove = function (params) {
	$.get(store.url(store.action.cartDelete, params), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartRemove');
		}
		else {
			store.message.error(data.message, data.title, null, 'cartRemove');
		}
	}, 'json');
};
store.cart.increase = function (params) {
	$.get(store.url(store.action.cartAdjust, params + '/1'), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartIncrease');
			store.local.onCartIncrease();
		}
		else {
			store.message.error(data.message, data.title, null, 'cartIncrease');
		}
	}, 'json');
};

store.cart.decrease = function (params) {
	$.get(store.url(store.action.cartAdjust, params + '/-1'), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartDecrease');
			store.local.onCartDecrease();
		}
		else {
			store.message.error(data.message, data.title, null, 'cartDecrease');
		}
	}, 'json');
};

store.cart.clear = function () {
	$.get(store.url(store.action.cartClear, ''), function (data) {
		if (data.success === true) {
			store.cart.box();
			store.cart.view();
			store.message.add(data.message, data.title, data.image, null, 'cartClear');
		}
		else {
			store.message.add(data.message, null, null, null, 'cartClear');
		}
	}, 'json');
};

store.cart.box = function () {
	$.get(store.url(store.action.cartBox, ''), function (data) {
		var $box = $('#storeCartBox');
		$box.find('.boxText').html(data.html);
		$box.effect("highlight", {color:"#ccc"}, 1000);
		store.local.onCartBox($box, data);
	}, 'json');
};

store.cart.view = function () {
	$.get(store.url(store.action.cartView, ''), function (data) {
		store.$().find('.cartView').replaceWith(data.html);
		store.responsiveImg(store.$().find('.cartView'));
	}, 'json');
};

store.cart.medium = function () {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$.fancybox({
			content: data.html
		});
	}, 'json');
};
store.cart.saved = {};
store.cart.saved.init = function() {
	var $form = $('#storeCartSave');
	if ($form.length < 1) {
		var $msg = $('#storeSavedCartSaved');
		if ($msg.length > 0) {
			tb_remove();
			store.message.add($msg.text(), $msg.text(), '', null, 'cartSaved');
		}
		return;
	}
	var $name = $form.find('#name');
	if ($name.length < 1) return;
	var $overwrite = $form.find('#elm_overwrite');
	var orig = $name.data('orig');
	var sources = [];
	if ($name.prop('tagName') === 'SELECT') {
		sources = $name.find('option').map(function(){
			return this.value;
		});
	}
	else {
		var tmp = $name.data('source');
		if (tmp) {
			sources = tmp.split(', ');
		}
		$overwrite.hide();
		var checkOverwrite = function(forcedValue) {
			var cName = (forcedValue) ? forcedValue : $name.val();
			$overwrite.find('#overwrite').prop('checked', false);
			if (cName === orig) {
				$overwrite.hide();
				$overwrite.find('#overwrite').prop('checked', true);
			}
			else if (sources.indexOf(cName) > -1) {
				$overwrite.show();
			}
			else {
				$overwrite.hide();
			}
		};
		$name.autocomplete({
			source: sources,
			select: function(event, ui) {
				checkOverwrite(ui.item.value);
			}
		});
		var delay = (function () {
			var timer = 0;
			return function (callback, ms) {
				clearTimeout(timer);
				timer = setTimeout(callback, ms);
			};
		})();
		$name.keyup(function() {
			delay(function(){
				checkOverwrite();
			}, 400);
		});

		var def = $name.data('default');
		if (def) {
			$name.val(def);
		}
		if ($name.val().length > 0) {
			checkOverwrite();
		}
	}
};
